import CalendarContainer from './CalendarContainer';

export default CalendarContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Calendar/index.js